/**
 * @generated SignedSource<<47eeeb10633274d57d6c9c30de6e48fe>>
 * @relayHash 4399885a7027d1430de63dd3a718b553
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4399885a7027d1430de63dd3a718b553

import { ConcreteRequest } from 'relay-runtime';
export type useRemoveAllAppointmentsMutation$variables = Record<PropertyKey, never>;
export type useRemoveAllAppointmentsMutation$data = {
  readonly removeAllAppointments: {
    readonly boolean: boolean | null;
  };
};
export type useRemoveAllAppointmentsMutation = {
  response: useRemoveAllAppointmentsMutation$data;
  variables: useRemoveAllAppointmentsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RemoveAllAppointmentsPayload",
    "kind": "LinkedField",
    "name": "removeAllAppointments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useRemoveAllAppointmentsMutation",
    "selections": (v0/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useRemoveAllAppointmentsMutation",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "4399885a7027d1430de63dd3a718b553",
    "metadata": {},
    "name": "useRemoveAllAppointmentsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "777bf6cf057c2f9a8c5db848d428ac75";

export default node;
